/** Shared by NavUserMenu and any other avatar-with-initials UI (LLMR-141's
 * requester picker/column) so every account in the product renders the same
 * 1-2 letter initials from the same rule. */
export function initials(nameOrEmail: string): string {
  const base = (nameOrEmail.includes('@') ? nameOrEmail.split('@')[0] : nameOrEmail)?.trim() ?? '';
  const parts = base.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0] ?? '';
  if (parts.length === 1) return first.slice(0, 2).toUpperCase();
  const second = parts[1] ?? '';
  return ((first[0] ?? '') + (second[0] ?? '')).toUpperCase() || '?';
}
